import { useInstance } from 'intact-vue';
export function useClick(getSlidingValue, fixValue, showValue, setValue) {
  var instance = useInstance();
  function onClickTrack(e) {
    if (instance.get('disabled')) return;
    var newValue = getSlidingValue(e.clientX);
    if (instance.get('range')) {
      newValue = generateRangeValue(newValue);
    }
    fixValue(newValue, true);
  }
  function generateRangeValue(v) {
    var _instance$get = instance.get('value'),
      min = _instance$get[0],
      max = _instance$get[1];
    if (Math.abs(min - v) <= Math.abs(max - v)) {
      return [v, max];
    } else {
      return [min, v];
    }
  }
  function setOneValue(v) {
    if (instance.get('disabled')) return;
    var newValue = v;
    if (instance.get('range')) {
      newValue = generateRangeValue(v);
    }
    showValue.set(newValue);
    setValue(newValue);
  }
  return {
    onClickTrack: onClickTrack,
    setOneValue: setOneValue
  };
}